import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import moment from 'moment';

const model = {
  state: {
    queryParams: {
      per_page: 50,
      cur_page: 1,
      time: [moment('00:00:00', 'HH:mm').subtract(14, 'day'), moment('23:59:59', 'HH:mm')],
    },
    listLoading: false,
    list: [],
    listTotal: 0,
    rewardDetailList: [],
    rewardDetailLoading: false,
    dealAdviceIds: [],
    adviceDetail: {},
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { advice, basic }, getState }) => ({
    // 获取意见列表
    async getList(isExport) {
      const { queryParams } = getState().advice;
      const { adviceType, time, userName, companyName, status, rewardFlag, cur_page, per_page } =
        queryParams;
      let createTimeBegin;
      let createTimeEnd;
      if (time && time.length === 2) {
        createTimeBegin = moment(time[0]).valueOf();
        createTimeEnd = moment(time[1]).valueOf();
      }
      advice.setState({ listLoading: true });
      const data = await fetch(
        isExport
          ? '/saasmerchant/web/user/exportAdviceList'
          : '/saasmerchant/web/user/queryAdviceList',
        {
          type: 'POST',
          useJson: true,
          params: filterNull({
            adviceType,
            createTimeBegin,
            createTimeEnd,
            userName,
            companyName,
            status,
            rewardFlag,
            page: cur_page,
            pageSize: per_page,
          }),
        },
      );
      advice.setState({ listLoading: false });
      if (data) {
        if (isExport) {
          basic.setLogListDot(true);
          message.success('导出成功');
        } else {
          advice.setState({
            list: data.adviceList,
            listTotal: data.total,
          });
        }
      }
    },
    // 搜索
    onSearch(queryParams) {
      advice.setState({ queryParams });
      advice.getList();
    },
    // 重置筛选项
    onReset() {
      advice.setState({
        queryParams: {
          per_page: 50,
          cur_page: 1,
          time: [
            moment('00:00:00', 'HH:mm:ss').subtract(14, 'day'),
            moment('23:59:59', 'HH:mm:ss'),
          ],
        },
      });
    },
    // 翻页
    onNav(page) {
      const { queryParams } = getState().advice;
      advice.setState({ queryParams: { ...queryParams, cur_page: page } });
      advice.getList();
    },
    // 查看奖励/赔付优惠券详情
    async getRewardDetail(adviceId) {
      advice.setState({ rewardDetailLoading: true, rewardDetailList: [] });
      const data = await fetch('/saasmerchant/web/user/rewardDetails', {
        type: 'GET',
        params: { adviceId },
      });
      advice.setState({ rewardDetailLoading: false });
      if (data) {
        advice.setState({
          rewardDetailList: data,
        });
      }
    },
    setDealAdviceIds(ids) {
      advice.setState({ dealAdviceIds: ids });
    },
    // 处理意见
    async dealAdvice(dealOptions, idDetail) {
      const { dealAdviceIds } = getState().advice;
      const data = await fetch('/saasmerchant/web/user/dealAdvices', {
        params: {
          adviceIds: dealAdviceIds,
          dealOptions,
        },
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('处理成功');
        if (idDetail) {
          advice.getAdviceDetail(dealAdviceIds[0]);
        } else {
          advice.getList();
        }
      }
    },
    // 获取意见详情
    async getAdviceDetail(adviceId) {
      const data = await fetch('/saasmerchant/web/user/showAdviceDetails', {
        params: { adviceId },
        type: 'GET',
      });
      if (data) {
        advice.setState({ adviceDetail: data });
      }
    },
    clearAdviceDetail() {
      advice.setState({ adviceDetail: {} });
    },
    setQueryParams(params) {
      const { queryParams } = getState().advice;
      advice.setState({ queryParams: { ...queryParams, ...params } });
    },
    // 发放优惠券
    async grantCoupon(params, callback) {
      const data = await fetch('/saasmerchant/web/user/grantCoupons', {
        params,
        type: 'POST',
        useJson: true,
      });
      if (data) {
        callback();
      }
    },
  }),
};

export default model;
